<template>
  <div>
    <div class="b-shop">
      <ul class="b-shop__tabs__wrapper">
        <span v-for="(item, index) in shopItemsTabs" :key="index">
          <li
            v-if="item.values.length !== 0"
            class="b-shop__tabs__item"
            :class="[activeTab('#' + item.id + '-section')]"
            @click="scrollToSection('#' + item.id + '-section')">
            {{ item.label }}
          </li>
        </span>
      </ul>
    </div>

    <div class="mt-5">
      <div
        v-for="(item, index) in shopItemsTabs"
        :id="'#' + item.id + '-section'"
        :key="index"
        class="b-shop__scroll">
        <div v-if="item.values.length > 0" class="b-shop__section-title">
          {{ item.label }}
        </div>
        <hr v-if="item.values.length > 0" class="b-shop__hr" />
        <template
          v-for="(product, itemIndex) in shopeItems[index].values"
          :key="`${product.cinemaId}${product.id}${itemIndex}`">
          <div
            class="b-ticket__el-holding-shop my-5"
            :class="isDisabledPointsProducts(product)">
            <!-- <div>
              <small>
                <pre>
                  {{ product }}
                </pre>
              </small>
            </div> -->

            <div class="b-shop__item">
              <img
                v-if="product.image"
                class="b-shop__item__img"
                :src="product.image"
                :alt="product.name" />
              <div class="b-shop__item__info-wrapper">
                <div class="b-ticket__title">{{ product.name }}</div>
                <div
                  class="b-ticket__price"
                  :class="
                    product.points > 0 ? 'b-ticket__price--withPoints' : ''
                  ">
                  {{ roundToDigits(product.price) }} €
                  <span v-if="product.points > 0">
                    {{ dictionary.pointsLabel.replace('{x}', product.points) }}
                  </span>
                </div>
              </div>
            </div>
            <div class="b-ticket__counter-wrapper-shop">
              <div>
                <slot name="remove" :product="product"></slot>
              </div>
              <div class="b-ticket__counter">
                <slot name="counter" :product="product"></slot>
              </div>
              <div>
                <slot name="add" :product="product"></slot>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import { useBookingStore } from '../../../store/BookingStore'

const store = useBookingStore()
const sectionObserver = ref(null)
const currentHash = ref(null)

const props = defineProps({
  shopeItems: {
    default() {
      return []
    },
    type: Array,
    required: true,
  },
})

const shopItemsTabs = computed(() => {
  return props.shopeItems
})

const activeTab = (step) => {
  return currentHash.value === step && 'b-shop__tabs__item--active'
}

const roundToDigits = (price) => {
  // return parseFloat(price).toFixed(2)
  return parseFloat(price).toLocaleString(document.documentElement.lang, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

onMounted(() => {
  if (props.shopeItems && props.shopeItems.length) {
    currentHash.value = `#${props.shopeItems[0].id}-section`
    addEventListener('hashchange', () => {
      currentHash.value = decodeURI(window.location.hash)
    })
    observeSections()
  }
})

onBeforeUnmount(() => {
  removeEventListener('hashchange', () => {
    observeSections()
  })
})

const observeSections = () => {
  try {
    if (sectionObserver.value) {
      sectionObserver.value.disconnect()
    }
  } catch (error) {
    console.error(error)
  }

  const options = {
    threshold: 0.5,
  }
  sectionObserver.value = new IntersectionObserver(
    sectionObserverHandler,
    options
  )

  // Observe each section
  const sections = document.querySelectorAll('.b-shop__scroll')
  sections.forEach((section) => {
    sectionObserver.value.observe(section)
  })
}

const sectionObserverHandler = (entries) => {
  for (const entry of entries) {
    if (entry.isIntersecting) {
      location.hash = `${entry.target.id}`
    }
  }
}

const scrollToSection = (sectionName) => {
  const element = document.getElementById(sectionName)
  if (element) {
    const sectionDimension = element.getBoundingClientRect()
    window.scrollTo({
      top: sectionDimension.top - 120,
      behavior: 'smooth',
    })
  }
}

const isDisabledPointsProducts = (product) => {
  if (store.bookingProgress.userShopItems) {
    const availablePoints = store.checkAvailablePoints(product.points)
    if (
      !(product.id in store.bookingProgress.userShopItems) &&
      !availablePoints
    ) {
      return 'b-ticket__el-holding-shop--disabled'
    }

    return ''
  }
}

// const sortedProducts = computed(() => {
//   if (shopItemsTabs.value.length) {
//     shopItemsTabs.value.forEach((category) => {
//       category.values.sort((a, b) => {
//         // Sort by active first, true should come before false
//         if (a.active !== b.active) {
//           return a.active === true ? -1 : 1
//         }
//         // If both are active or both inactive, sort by price
//         return a.price - b.price
//       })
//     })
//   }
//   return shopItemsTabs.value
// })
</script>
